// [PURPOSE]: Single source of truth for the app's display version.
// [WHY]: Version was previously hardcoded in App.jsx and stale in sourcesManager.js;
//        derived from package.json so a single bump there propagates everywhere.
// [INTEGRATION]: import { APP_VERSION } from '../constants/version';

import pkg from '../../package.json';

export const APP_VERSION = pkg.version;
